import { render, staticRenderFns } from "./QuantityForm.vue?vue&type=template&id=16cc2cd6&"
import script from "./QuantityForm.vue?vue&type=script&lang=js&"
export * from "./QuantityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports